import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import PropTypes from 'prop-types';

const ModalTemplate = ({ title, body, open, onClose, buttons, text, fullScreen, width = 650 }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: fullScreen ? '90%' : width,
          height: fullScreen ? '90%' : 'auto',
          maxHeight: '90%',
          overflowY: 'auto',
          bgcolor: 'background.paper',
          border: 'none',
          outline: 'none',
          p: 4,
          borderRadius: 5,
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {title}
        </Typography>
        {text && (
          <Typography
            variant={title.includes('Error') ? 'body1' : 'p'}
            component={title.includes('Error') ? 'div' : 'p'}
          >
            {text}
          </Typography>
        )}

        {body}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 3,
          }}
        >
          {buttons}
        </Box>
      </Box>
    </Modal>
  );
};

ModalTemplate.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  body: PropTypes.element,
  buttons: PropTypes.array,
  text: PropTypes.string,
};

export default ModalTemplate;
